import script from "./CadastreView.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastreView.vue?vue&type=script&setup=true&lang=js"

import "./CadastreView.vue?vue&type=style&index=0&id=9d14be2c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d14be2c"]])

export default __exports__